import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

const HVendTechnicanDashboard = () => {
	return (
		<Routes>
			<Route path="/" element={<Navigate to="/hardwareManagement" replace />} />
			<Route path="/dashboard" element={<Navigate to="/hardwareManagement" replace />} />
		</Routes>
	);
};

export default HVendTechnicanDashboard;
